'use client';

import { __makeTemplateObject } from '../_virtual/_tslib.js';
import styled, { css } from 'styled-components';
import { colors } from '../Colors/index.js';

var AutoCompleteContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var InputRecommend = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    z-index: 2;\n    width: 100%;\n    max-height: 250px;\n    overflow: auto;\n    margin-top: 8px;\n    background: #fff;\n    box-shadow: 0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1);\n    border-radius: 3px;\n"], ["\n    z-index: 2;\n    width: 100%;\n    max-height: 250px;\n    overflow: auto;\n    margin-top: 8px;\n    background: #fff;\n    box-shadow: 0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1);\n    border-radius: 3px;\n"])));
var ListRecommend = styled.ul(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding: 0;\n    margin: 0;\n    list-style: none;\n"], ["\n    padding: 0;\n    margin: 0;\n    list-style: none;\n"])));
var RecommendItem = styled.li(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    padding: 8px 16px;\n    cursor: pointer;\n    ", "\n    ", "\n"], ["\n    padding: 8px 16px;\n    cursor: pointer;\n    ", "\n    ", "\n"])), function (_a) {
    var isActive = _a.isActive, isHover = _a.isHover;
    if (!isActive && !isHover) {
        return '';
    }
    return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n            background: #f2f2f2;\n        "], ["\n            background: #f2f2f2;\n        "])));
}, function (_a) {
    var isEmpty = _a.isEmpty;
    if (!isEmpty) {
        return '';
    }
    return css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n            color: ", ";\n        "], ["\n            color: ", ";\n        "])), colors.grey[60]);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;

export { AutoCompleteContainer, InputRecommend, ListRecommend, RecommendItem };
//# sourceMappingURL=styles.js.map
